import _ from 'lodash'
import { EventBus } from 'light-event-bus'

let component = {
    id: 'event_manager',
    api: null,
    subscriptions: {},
    eventBus: null,
    events: {
        EVENT_ON_CREATE: 'forms__onCreateForm',                         // cada vez que se hace un update en la pagina
        EVENT_ON_UPDATE: 'forms__onUpdate',                         // cada vez que se hace un update en la pagina
        EVENT_ON_PAGE_VALIDATION: 'forms__onPageValidation',
        EVENT_ON_PAGE_VALIDATION_ERRORS: 'forms__onPageValidationErrors',
        EVENT_ON_PAGE_CHANGE: 'forms__onPageChange',
        EVENT_ON_BORRADOR_ALMACENADO: 'forms__onBorradorAlmacenado'
    }
}


component.setClientAPI = (c) => {
    component.api = c
    if (component.eventBus) component.clearSubscriptions()
    component.eventBus = component.eventBus || new EventBus()
}


const split_event_name = eventName => {
    if (!eventName) return []
    let r = eventName
    if (Array.isArray(eventName)) return r
    r = eventName?.split(' ')?.map(e => e?.replaceAll(',', '')?.replaceAll(';', '')?.replaceAll(':', '')?.trim())
    if (!Array.isArray(r)) console.log('**** split_event_name', eventName, r)
    return r

}

/**
 * hay 2 formas de registrarse a eventos. A traves de eventSubscribe, y deben ser notificados a traves
 * del event bus.
 * La segunda es a traves de @<nombre_evento>=callback en el elemento HTML. En ese caso, se debe
 * hacer dispatch del evento al elemento. En el constructor del elemento se mira el HTML, se buscan
 * las anotaciones @event_name y se guarda el indice en window.domListeners. Asi que para
 * notificar a estos, basta con hacer este lookup.
 */
component.eventPublish = (eventName, eventDetails) => {

    window.Vue.nextTick(() => {
        // const notif = {}
        const events = split_event_name(eventName)
        _.each(events, the_event_name => {

            component.eventBus.publish(the_event_name, eventDetails)
            let evt = new CustomEvent(the_event_name, eventDetails?.detail ? eventDetails : { detail: eventDetails })

            const listeners = window.domListeners?.[the_event_name]
            listeners?.forEach(nodeUUID => {
                const el = document.querySelector(`[__id="${nodeUUID}"]`)
                el?.dispatchEvent(evt)
            })

            window.console.log('eventPublish', the_event_name, eventDetails?.slice ? eventDetails.slice(0, 50): eventDetails)
        })
    })
}

component.eventSubscribe = (caller, eventName, callback) => {
    if (!eventName) return
    if (!callback) return

/*
    if (Array.isArray(eventName)) {
        _.each(eventName, e => component.eventSubscribe(caller, e, callback))
        return
    }
*/

    const events = split_event_name(eventName)
    _.each(events, ename => {
        let k = (caller?.nodeUUID || caller?.id || caller?.name || caller) + "-" + ename;

        // console.log(`window.creation_runs ${window.creation_runs} eventSubscribe ${k} ${ename}`)
        switch (ename) {
            case 'popstate':
                window.addEventListener(ename, callback)
                break;
            default:
                if (component.subscriptions[k]) component.subscriptions[k].unsubscribe()
                component.subscriptions[k] = component.eventBus.subscribe(ename, event => {
                    callback(event)
                });
                return component.subscriptions[k]
        }
    })
}


component.scrollTo = (selector, opts) => {
    let st = document.getElementById(selector)
    let st2 = [...document.getElementsByClassName(selector)]

    opts = opts || { behavior: 'smooth', block: "start", inline: "nearest" }
    if (st) st.scrollIntoView(opts);
    if (st2.length) st2[0].scrollIntoView(opts);
}

component.clearSubscriptions = () => {
    const subs = Object.keys(component.subscriptions).filter(k => k != 'event_manager-forms__onCreateForm')
    for (const s of subs) {
        // console.log('unsbuscribe ' + s)
        component.subscriptions[s].unsubscribe()
        delete component.subscriptions[s]
    }
    component.eventBus = new EventBus()
}

export default component;